import {
    FETCHING_GENERATED_REPORT,
    FETCHING_GENERATED_REPORT_SUCCEEDED,
    FETCHING_GENERATED_REPORT_FAILED,
    GENERATING_REPORT_REQUEST,
    GENERATING_REPORT_REQUEST_SUCCEEDED,
    GENERATING_REPORT_REQUEST_FAILED,
} from "constants/actionTypes";


const initState = {
    items: [],
    pagination: {
        currentPage: 0,
        totalPages: 1,
        recordsPerPage: 20,
        totalRecordsCount: 0,
    },
    count: {
        all: {
            fetching: false,
            total: 0,
            error: null,
        },
    },
    loading: false,
    report: null,
    generatingReport: {
        generating: false,
        success: false,
        error: null,
    },
};

function generateReportReducer(state = initState, action) {
    switch (action.type) {
        case FETCHING_GENERATED_REPORT: {
            const { page = 0 } = action.payload || {};

            return {
                ...state,
                loading: true,
                ...(page === 0 && {
                    items: [],
                    pagination: {
                        currentPage: -1,
                        totalPages: 1,
                        recordsPerPage: 20,
                        totalRecordsCount: 0,
                    },
                }),
            };
        }

        case FETCHING_GENERATED_REPORT_SUCCEEDED: {
            const {
                pageable: { pageNumber: currentPage, pageSize: recordsPerPage },
                totalPages,
                totalElements: totalRecordsCount,
                content: records = [],
            } = action.payload;

            const items = currentPage !== 0 ? [...state.items, ...records] : records;

            return {
                ...state,
                loading: false,
                items,
                pagination: {
                    currentPage,
                    totalPages,
                    recordsPerPage,
                    totalRecordsCount,
                },
            };
        }
        case FETCHING_GENERATED_REPORT_FAILED: {
            return {
                ...state,
                loading: false,
                pagination: {
                    ...state.pagination,
                },
            };
        }

        case GENERATING_REPORT_REQUEST: {
            return {
                ...state,
                generatingReport: {
                    generating: true,
                    success: false,
                    error: null,
                },
            };
        }

        case GENERATING_REPORT_REQUEST_SUCCEEDED: {
            const newReport = action.payload;
            return {
                items: [newReport, ...state.items], 
                generatingReport: {
                    generating: false,
                    success: true,
                    error: null,
                },
            };
        }

        case GENERATING_REPORT_REQUEST_FAILED: {
            const error =
                action.payload?.errors?.[0]?.message || "Unknown error";

            return {
                ...state,
                generatingReport: {
                    generating: false,
                    success: false,
                    error
                },
            };
        }

        default:
            return state;
    }
}


export { generateReportReducer };
